import React from 'react';
import { IOS_SUBSCRIPTION_MANAGE_MESSAGE } from '../utils/iosCommerceGate';

const DEFAULT_STYLE = {
  fontSize: 14,
  lineHeight: 1.6,
  color: 'var(--text-secondary, rgba(255,255,255,0.55))',
  margin: 0,
};

/**
 * App Store 3.1.1 — no in-app subscribe/checkout/portal surfaces on iOS (#408).
 */
export default function IosSubscriptionManageHint({ style, className, centered = false }) {
  return (
    <p
      className={className}
      data-testid="ios-subscription-manage-hint"
      style={{
        ...DEFAULT_STYLE,
        ...(centered ? { textAlign: 'center' } : null),
        ...style,
      }}
    >
      {IOS_SUBSCRIPTION_MANAGE_MESSAGE}
    </p>
  );
}
